
export default function ClientReviewsSection() {
  const reviews = [
    {
      rating: 5,
      text: "Sylman Academy's approach to skills development is unmatched. They understood our unique challenges and delivered solutions that exceeded our expectations.",
      name: "Thabo Mthembu",
      title: "HR Director",
      sector: "Manufacturing"
    },
    {
      rating: 5,
      text: "The quality of training and ongoing support has been exceptional. Our team's productivity and morale have improved significantly since partnering with Sylman Academy.",
      name: "Sarah van der Merwe",
      title: "Operations Manager",
      sector: "Logistics"
    },
    {
      rating: 5,
      text: "Working with Sylman Academy was a game-changer for our business. Their expertise in SETA compliance saved us time and money while ensuring we met all requirements.",
      name: "Michael Khumalo",
      title: "Skills Development Facilitator",
      sector: "Financial Services"
    },
    {
      rating: 5,
      text: "The customised training programmes delivered real results. We've seen measurable improvements in customer satisfaction and employee retention.",
      name: "Jennifer Naidoo",
      title: "Training Coordinator",
      sector: "Retail"
    },
    {
      rating: 5,
      text: "Sylman Academy's team is professional, knowledgeable, and genuinely committed to our success. They've become a trusted partner in our growth journey.",
      name: "David Molefe",
      title: "General Manager",
      sector: "Hospitality"
    },
    {
      rating: 5,
      text: "The ROI on our training investment has been remarkable. Our employees are more skilled, confident, and engaged than ever before.",
      name: "Lisa Botha",
      title: "People Development Manager",
      sector: "Technology"
    }
  ];

  return (
    <section className="section-wrap bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Client Reviews
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Hear directly from our clients about their experience working with Sylman Academy.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              {/* Stars */}
              <div className="flex mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              {/* Review Text */}
              <blockquote 
                className="text-gray-700 mb-6 leading-relaxed italic"
                
              >
                "{review.text}"
              </blockquote>

              {/* Author */}
              <div className="border-t pt-4">
                <div className="font-semibold text-[#1A1A1A]">{review.name}</div>
                <div className="text-gray-600 text-sm">{review.title}</div>
                <div className="text-[#2D7F3E] text-sm font-medium">{review.sector}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
